import { RoverBrand } from '@rover/types/src/RoverBrand';

import getRoverBrandFromHostname from './getRoverBrandFromHostname';

const getRoverBrand = (): RoverBrand => {
  // Use window.location.hostname to determine the brand based on domain
  const { hostname } = window.location;

  return getRoverBrandFromHostname(hostname);
};

export default getRoverBrand;
